const VoucherReconciliationHistoryType = {
  APPROVED: 1,
  REJECTED: 2,
  CREATED: 3,
  DELETED: 4,
  SENT: 5
}
export default VoucherReconciliationHistoryType
